import {
  Col,
  Row,
  Container,
  Button,
  Form,
  Card,
  CardBody,
  FormGroup,
  Input,
  Spinner,
} from 'reactstrap';
import { ChangeEvent, FormEvent, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo_onetimeoxy from 'assets/images/logos/logo_ontimeoxy.png';
import logoRas from 'assets/images/logos/ras.png';
import logoRedAndFly from 'assets/images/logos/redandfly.png';
import { LogoLlargInducontrol } from 'components/LogoInducontrol';
import { LoginRequest } from 'service/apicataleg/types/ApiCatalegTypes';

import useApiAuth from 'service/apicataleg/useApiAuth';

const LoginPage: React.FC = () => {
  const [cred, setCreds] = useState<LoginRequest>({
    username: '',
    password: '',
  });

  const { doLogin, isAuthenticated, loginError, isFetching } = useApiAuth();
  const { t } = useTranslation('common');

  const handleInputChange = ({ target }: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = target;
    setCreds({ ...cred, [name]: value });
  };

  const handleSubmit = (evt: FormEvent) => {
    evt.preventDefault();
    doLogin(cred.username, cred.password);
  };

  return isAuthenticated ? (
    <Navigate to="/" />
  ) : (
    <section className="vh-100">
      <Container className="h-100">
        <Row className="justify-content-center align-items-center h-100">
          <Col className="col-12 col-md-8 col-lg-6 col-xl-5">
            <Card className="shadow-2-strong border rounded">
              <CardBody>
                <div className="p-2">
                  <Row className="mb-3 text-center justify-content-center">
                    <h2>Catalog</h2>
                    <div className="mb-3">
                      <div>
                        <img className="mw-100" src={logo_onetimeoxy} alt="OnetimeOxy" />
                      </div>
                      <div className="d-flex">
                        <div>
                          <img className="mw-100" src={logoRas} alt="RAS" />
                        </div>
                        <div>
                          <img className="mw-100" src={logoRedAndFly} alt="Red&Fly" />
                        </div>
                      </div>
                    </div>
                  </Row>

                  {isFetching ? (
                    <div className="d-flex justify-content-center mb-3">
                      <Spinner />
                    </div>
                  ) : loginError ? (
                    <Row className="mb-2">
                      <h5 className="text-center text-danger">Login failed</h5>
                    </Row>
                  ) : null}

                  <Form onSubmit={handleSubmit}>
                    <FormGroup>
                      <Input
                        name="username"
                        placeholder="Username"
                        type="text"
                        onChange={handleInputChange}
                        disabled={isFetching}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Input
                        name="password"
                        placeholder="Password"
                        type="password"
                        onChange={handleInputChange}
                        disabled={isFetching}
                      />
                    </FormGroup>

                    <Button
                      className="btn btn-primary w-100"
                      type="submit"
                      disabled={!cred.password || !cred.username}
                    >
                      {t('login')}
                    </Button>
                  </Form>
                </div>
                <div className="mt-5 d-flex justify-content-end">
                  <LogoLlargInducontrol />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default LoginPage;
